import ChapterIndex from '@/views/chapters/ChapterIndex.vue';
import AddChapter from '@/views/chapters/AddChapter.vue';
import EditChapter from '@/views/chapters/EditChapter.vue';

export default [
  {
    path: '/chapters',
    name: 'chapters.index',
    component: ChapterIndex,
    meta: { 
      title: 'chapters.indexTitle', 
      requiresAuth: true,
      requiredPerm: 'chapters.display'
    },
    children: [
      {
        path: 'add',
        name: 'chapters.create',
        component: AddChapter,
        meta: { 
          title: 'chapters.addTitle', 
          requiresAuth: true,
          requiredPerm: 'chapters.create'
        }
      },
      {
        path: ':id/edit',
        name: 'chapters.edit',
        component: EditChapter,
        meta: { 
          title: 'chapters.editTitle', 
          requiresAuth: true,
          requiredPerm: 'chapters.update'
        },
        props: true
      }
    ]
  }
];
